import React from 'react'

import './aboutCaption.scss'


const AboutCaption = () => {
    return (
        <div className="about_caption">
            <div className="about_caption_main">About <span className="about_caption_sub">Us</span>!</div>
            <div className="about_caption_aside">Kadoshiservices.com is an effective website aimed at converging artisans/vendors with prospective 
            clients on the cyber space.</div>
        </div>
    )
}

export default AboutCaption;